<div [@fadeAnimation]>
  <div class="gridster-container" *ngIf="showGridster">
    <gridster
      [ngClass]="editMode ? 'edit-mode' : 'display-mode'"
      [options]="options">
      <ng-container *ngFor="let widget of dashboard">
        <gridster-item [item]="widget.item" [ngClass]="this.colorScheme">
          <!-- WIDGETS -->
          <span
            *ngIf="editMode"
            (click)="removeWidget(widget)"
            [pTooltip]="'widgets.general.remove' | translate"
            class="pi pi-trash text-red-500 mr-2 remove-widget"></span>

          <div
            class="cursor-pointer empty-widget"
            (click)="showWidgetChooserModal(widget.id ? widget.id : 0)"
            *ngIf="widget.component === 'app-widget-empty' && editMode">
            <app-widget-empty class="widget"></app-widget-empty>
          </div>

          <!-- WIDGETS -->
          <span
            *ngIf="editMode"
            (click)="removeWidget(widget)"
            [pTooltip]="'widgets.general.remove' | translate"
            class="pi pi-trash text-red-500 mr-2 remove-widget"></span>

          <app-widget-users
            *ngIf="widget.component === 'app-widget-users'"
            [editMode]="editMode"
            [colorScheme]="colorScheme"
            class="widget"></app-widget-users>
        </gridster-item>
      </ng-container>
    </gridster>
  </div>

  <div
    *ngIf="!editMode"
    class="text-primary pl-3 pt-2 configure-dashboard"
    (click)="toggleEditMode()">
    <span class="pi pi-th-large"></span
    ><span class="ml-2">{{ 'widgets.general.configure' | translate }}</span>
  </div>

  <div class="flex gap-2 pt-1">
    <button
      *ngIf="editMode && $can('update')"
      pButton
      pRipple
      type="button"
      [label]="'widgets.general.save' | translate"
      class="p-button-outlined py-1"
      (click)="saveDashboard()"></button>
  </div>
  <p-dialog
    *ngIf="widgetChooserModalVisible"
    [draggable]="false"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [(visible)]="widgetChooserModalVisible"
    (onHide)="hideWidgetChooserModal()"
    [modal]="true"
    [style]="{ width: '75%' }">
    <!-- Dialog Header -->
    <ng-template pTemplate="header">
      <h2>{{'widgets.general.addWidget'| translate }}</h2>
    </ng-template>

    <app-widget-chooser
      (selectedWidgetHasChanged)="selectedWidgetsChange($event)"
      [dashboard]="dashboard"></app-widget-chooser>
  </p-dialog>
</div>
